<template>
  <div class="editorial-board">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="editorial-board-module"
    >
      <p class="duties">{{ item["type"] }}</p>
      <div v-for="staff in item['list']" :key="staff.id" class="staff">
        <div class="staff-img">
          <img :alt="staff.name" :src="staff['imgs']" />
        </div>
        <div class="staff-info">
          <p>
            <span class="name">{{ staff["name"] }}</span>
            <span class="school">{{ staff["university"] }}</span>
          </p>
          <p><span class="label">邮 箱：</span>{{ staff["email"] }}</p>
          <p><span class="label">研究兴趣：</span>{{ staff["study"] }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EditorialBoard",
  data() {
    return {
      list: [
        // {
        //   img: require('@/assets/img/journal/head/wgz.png'),
        //   duties: '主编',
        //   name: '王国长（Guochang Wang）',
        //   school: '暨南大学（Jinan University）',
        //   email: 'wanggc023@amss.ac.cn',
        //   interest: '函数型数据分析、时间序列、充分性降维、统计与机器学习(Functional data analysis, time series, sufficiency dimension reduction, statistics and machine learning)'
        // },
        // {
        //   img: require('@/assets/img/journal/head/zxf.png'),
        //   duties: '执行副主编： ',
        //   name: '张兴发 （Xingfa Zhang）',
        //   school: '广州大学 （Guangzhou University）',
        //   email: 'xingfazhang@gzhu.edu.cn',
        //   interest: '金融统计、环境统计、机器学习(Financial statistics, environmental statistics, machine learning)'
        // },
        // {
        //   img: require("@/assets/img/journal/head/slj.png"),
        //   duties: "",
        //   name: "舒连杰（Lianjie Shu）",
        //   school: "澳门大学（University of Macau）",
        //   email: "ljshu@um.edu.mo",
        //   interest:
        //     "量化金融，统计学习，质量控制及管理（Quantitative Finance, Statistical Learning, Quality Control and Management)）",
        // },
        // {
        //   img: require("@/assets/img/journal/head/zk.png"),
        //   duties: "",
        //   name: "朱柯（Ke Zhu）",
        //   school: "香港大学（The University of Hong Kong）",
        //   email: "mazhuke@hku.hk",
        //   interest:
        //     "统计建模、金融时间序列分析、计量经济、金融大数据（Statistical modeling, financial time series analysis, econometrics, financial big data）",
        // },
        // {
        //   img: require("@/assets/img/journal/head/zy.png"),
        //   duties: "",
        //   name: "周彦（Yan Zhou）",
        //   school: "深圳大学（Shenzhen University）",
        //   email: "zhouy1016@163.com",
        //   interest: "生物统计，数据科学（Biostatistics，data science）",
        // },
        // {
        //   img: require("@/assets/img/journal/head/yxd.png"),
        //   duties: "",
        //   name: "严晓东（Xiaodong Yan）",
        //   school: "西安交通大学（Xi’an Jiaotong University）",
        //   email: "yanxiaodong@xjtu.edu.cn",
        //   interest:
        //     "统计机器学习、智能体统计学（Statistical Machine Learning，agent Statistics）",
        // },
        // {
        //   img: require("@/assets/img/journal/head/lzd.png"),
        //   duties: "",
        //   name: "刘照德（Zhaode Liu）",
        //   school: "广东财经大学（Guangdong University of Finance & Economics）",
        //   email: "lzhaode@163.com",
        //   interest:
        //     "经济统计、多元统计、计量分析（Economic statistics，multivariate statistics，econometric analysis）",
        // },
        // {
        //   img: require("@/assets/img/journal/head/wxg.png"),
        //   duties: "",
        //   name: "王小刚（Xiaogang Wang）",
        //   school: "北方民族大学（North Minzu University）",
        //   email: "wongone@163.com",
        //   interest: "经济与社会统计（Economic and social statistics）",
        // },
        // {
        //   img: require("@/assets/img/journal/head/ltl.png"),
        //   duties: "",
        //   name: "雷田礼（Tianli Lei）",
        //   school: "深圳职业技术大学（ShenZhen Polytechnic University）",
        //   email: "ltl@szpu.edu.cn",
        //   interest:
        //     "数量经济、高职数学教育（Quantitative Economics，higher vocational mathematics education）",
        // },
        // {
        //   img: require("@/assets/img/journal/head/yk.png"),
        //   duties: "",
        //   name: "杨凯（Kai Yang）",
        //   school: "长春工业大学（Changchun University of Technology）",
        //   email: "yangkai@ccut.edu.cn",
        //   interest:
        //     "时间序列分析、高维数据分析、贝叶斯分析（Time series analysis， high-dimensional data analysis， bayesian analysis）",
        // },
        // {
        //   img: require("@/assets/img/journal/head/ww.png"),
        //   duties:
        //     "山东财经大学（Shandong University of Finance and Economics）",
        //   name: "王纬（Wei Wang）",
        //   school: "",
        //   email: "wangwei_0115@sdufe.edu.cn",
        //   interest:
        //     "统计机器学习、应用统计、计量经济（Statistical Machine Learning，Applied Statistics, Econometrics）",
        // },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$request.getBoardList().then((res) => {
        if (res.code === 200) {
          this.list = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.editorial-board {
  padding: 0 55px;
  margin-top: 20px;
}

.editorial-board-module {
  border-top: 1px solid #eaeaea;
  overflow: hidden;
  padding: 20px 0 20px;

  .staff {
    margin-top: 20px;

    display: flex;

    .staff-img {
      width: 108px;
      height: 139px;
      margin-right: 25px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .staff-info {
      flex: 1;

      p {
        font-size: 16px;
        color: #333333;
        line-height: 30px;
        text-align: justify;
      }

      .name {
        font-size: 16px;
        color: #0012ff;
      }

      .school {
        font-size: 16px;
        color: #333333;
        margin-left: 20px;
      }
    }
  }

  .label {
    font-weight: bold;
  }
}

.duties {
  position: relative;
  height: 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 30px;
  padding-left: 10px;

  &:before {
    content: "";
    position: absolute;
    top: 12px;
    left: 0;
    width: 6px;
    height: 6px;
    background: #406cdd;
    border-radius: 50%;
  }
}
</style>
